/**
 * Get single-use CSRF token.
 * 
 * @returns {Object} - Response object with "token" property.
 */

async function getToken() {
  return await (
    await fetch('/stage-ajax/getToken/')
  ).json().catch(() => ({
    token: ''
  }));
}

export default getToken;